import { useQuery } from '@tanstack/react-query';
import { organizationsApi } from '@/api/organizations.api';
import type { OrganizationResponse } from '@/types/organization';
import { queryKeys, tierOptions } from '@/lib/query';

export const CURRENT_ORG_QUERY_KEY = queryKeys.organization.me;

export function useCurrentOrganization(enabled = true) {
  return useQuery({
    queryKey: queryKeys.organization.me,
    queryFn: () => organizationsApi.getCurrent(),
    enabled,
    ...tierOptions('master', {
      staleTime: Number.POSITIVE_INFINITY,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }),
  });
}

export function resolveCountryCode(
  org: OrganizationResponse,
  countries: { code: string; label: string }[],
): string {
  if (org.countryCode) return org.countryCode;
  const byLabel = countries.find((c) => c.label === org.country);
  if (byLabel) return byLabel.code;
  const byCode = countries.find((c) => c.code === org.country);
  return byCode?.code ?? '';
}
